export default __webpack_public_path__ + "book_details-advanced_type_setting.3d93a1eb.png";